module.exports = __webpack_public_path__ + "img/symbol_7.1275c54c.png";